import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import Firebase from '../../components/Firebase.js';
import './GroupPostPage.css';

// Trang admin: Quản lí bài đăng nhóm.
// - Tab "Bài đăng": liệt kê MỌI bài đăng nhóm đã duyệt (mọi group), sort thời gian giảm dần, cuộn để tải thêm (cursor).
// - Tab "Kháng cáo": hàng chờ kháng cáo (appealStatus=PENDING), CŨ NHẤT TRƯỚC — người chờ lâu nhất được xem trước.
//   Kháng cáo không bắn Slack và không bắn mail: nó báo về đúng trang này, nên badge số trên tab là thứ duy nhất
//   cho biết có việc đang chờ. Đừng bỏ nó đi.
// - Bấm vào 1 dòng → mở modal CHI TIẾT bài đăng (bố cục giống trang chi tiết mobile): người đăng (avatar/level/VIP),
//   caption, media/video, thống kê, và danh sách bình luận đọc trực tiếp từ RTDB (ikara/recordingComments).
// - Nút "Ẩn": ẩn bài khỏi CẢ newsfeed (mobile/v3/newsfeed) và group newsfeed (mobile/v1/groups/news-feed).
//   Nút "Hiện": đảo ngược.
// - Nút "Chấp nhận" (kháng cáo): gỡ chặn bài. Nút "Từ chối": giữ nguyên kết luận, chủ bài hết quyền kháng cáo.
export default class GroupPostPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tab: 'POSTS',          // POSTS = danh sách bài đăng, APPEALS = hàng chờ kháng cáo
            reviewStatus: '',
            posts: [],
            cursor: null,
            isLoading: false,
            appealCount: 0,        // số kháng cáo đang chờ — badge trên tab
            detail: null,          // AdminGroupPostDetailDTO đang xem (null = đóng modal)
            detailLoading: false,
            comments: [],          // bình luận đọc từ RTDB
            commentsLoading: false,
        };
        this.ikaraNode = Firebase.database().ref('ikara');
        this.fetchData = this.fetchData.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.toggleHidden = this.toggleHidden.bind(this);
        this.openDetail = this.openDetail.bind(this);
        this.closeDetail = this.closeDetail.bind(this);
        this.switchTab = this.switchTab.bind(this);
        this.resolveAppeal = this.resolveAppeal.bind(this);
        this.changeReviewStatus = this.changeReviewStatus.bind(this);
        this.listRequestId = 0;
    }

    componentDidMount() {
        this.fetchData(null);
        this.fetchAppealCount();
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    // Endpoint của tab đang mở. Hai tab dùng CHUNG state posts/cursor: chúng không bao giờ hiện
    // cùng lúc, và giữ hai bộ state song song chỉ tạo ra cơ hội hiện nhầm dữ liệu của tab kia.
    listUrl() {
        return global.config.apiDomain + (this.state.tab === 'APPEALS'
            ? '/mc-live-room/web/group-posts/appeals'
            : '/mc-live-room/web/group-posts/list');
    }

    switchTab(tab) {
        if (this.state.tab === tab) return;
        this.listRequestId++;
        this.setState({ tab, posts: [], cursor: null, isLoading: false }, () => {
            this.fetchData(null);
            this.fetchAppealCount();
        });
    }

    changeReviewStatus(event) {
        const reviewStatus = event.target.value;
        this.listRequestId++;
        this.setState({ reviewStatus, posts: [], cursor: null, isLoading: false }, () => this.fetchData(null));
    }

    fetchAppealCount() {
        axios.post(global.config.apiDomain + '/mc-live-room/web/group-posts/appeals/count', {})
            .then(res => {
                if (res.data.status === 'OK') {
                    this.setState({ appealCount: res.data.data || 0 });
                }
            })
            .catch(() => { /* badge hỏng thì thôi, không chặn cả trang */ });
    }

    fetchData(cursor) {
        if (this.state.isLoading) return;
        this.setState({ isLoading: true });

        const requestId = ++this.listRequestId;
        const body = this.state.tab === 'POSTS'
            ? { cursor, reviewStatus: this.state.reviewStatus || null }
            : { cursor };
        axios.post(this.listUrl(), body)
            .then(res => {
                if (requestId !== this.listRequestId) return;
                if (res.data.status === 'OK') {
                    const page = res.data.data || {};
                    const list = page.content || [];
                    this.setState({
                        posts: cursor ? [...this.state.posts, ...list] : list,
                        cursor: page.cursor,
                        isLoading: false,
                    });
                } else {
                    toast.error('Không tải được danh sách: ' + res.data.message);
                    this.setState({ isLoading: false });
                }
            })
            .catch(() => {
                if (requestId !== this.listRequestId) return;
                toast.error('Có lỗi khi tải danh sách bài đăng nhóm!');
                this.setState({ isLoading: false });
            });
    }

    // Chấp nhận (accept=true) → gỡ chặn bài. Từ chối → giữ nguyên kết luận, chủ bài hết quyền kháng cáo.
    resolveAppeal(post, accept) {
        const confirmMsg = accept
            ? 'Chấp nhận kháng cáo? Bài sẽ được hiện lại trên mọi newsfeed.'
            : 'Từ chối kháng cáo? Bài vẫn bị ẩn và chủ bài KHÔNG kháng cáo lại được nữa.';
        if (!window.confirm(confirmMsg)) return;

        const url = global.config.apiDomain + '/mc-live-room/web/group-posts/appeals/resolve/'
            + post.liveRoomId + '/' + post.recordingId;

        axios.post(url, { accept })
            .then(res => {
                if (res.data.status !== 'OK') {
                    toast.error('Thao tác thất bại: ' + res.data.message);
                    return;
                }
                toast.success(accept ? 'Đã chấp nhận kháng cáo.' : 'Đã từ chối kháng cáo.');
                const appealStatus = accept ? 'ACCEPTED' : 'REJECTED';
                const reviewStatus = accept ? 'ALLOWED' : 'BLOCKED';
                const laBai = p => p.recordingId === post.recordingId && p.liveRoomId === post.liveRoomId;
                this.setState(prev => ({
                    // Ở tab hàng chờ thì bài vừa xử phải rời danh sách — nó không còn PENDING nữa.
                    posts: prev.tab === 'APPEALS'
                        ? prev.posts.filter(p => !laBai(p))
                        : prev.posts
                            .map(p => (laBai(p) ? { ...p, appealStatus, reviewStatus } : p))
                            .filter(p => !prev.reviewStatus || p.reviewStatus === prev.reviewStatus),
                    detail: prev.detail && laBai(prev.detail)
                        ? { ...prev.detail, appealStatus, reviewStatus } : prev.detail,
                    appealCount: Math.max(prev.appealCount - 1, 0),
                }));
            })
            .catch(() => toast.error('Có lỗi khi xử lý kháng cáo!'));
    }

    handleScroll() {
        if (this.state.cursor === 'END' || this.state.isLoading || this.state.detail) return;

        const windowHeight = window.innerHeight;
        const documentHeight = document.documentElement.scrollHeight;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (windowHeight + scrollTop >= documentHeight - 100) {
            this.fetchData(this.state.cursor);
        }
    }

    // Ẩn (hide=true) / Hiện (hide=false) một bài; cập nhật state row + modal đang mở (nếu có).
    toggleHidden(post, hide) {
        const confirmMsg = hide
            ? 'Ẩn bài đăng này khỏi tất cả newsfeed? Không ai còn nhìn thấy.'
            : 'Hiện lại bài đăng này trên newsfeed?';
        if (!window.confirm(confirmMsg)) return;

        const action = hide ? 'hide' : 'show';
        const url = global.config.apiDomain
            + '/mc-live-room/web/group-posts/' + action + '/' + post.liveRoomId + '/' + post.recordingId;

        axios.post(url, {})
            .then(res => {
                if (res.data.status === 'OK') {
                    toast.success(hide ? 'Đã ẩn bài đăng.' : 'Đã hiện lại bài đăng.');
                    const newStatus = hide ? 'BLOCKED' : 'ALLOWED';
                    this.setState(prev => ({
                        posts: prev.posts
                            .map(p => (p.recordingId === post.recordingId && p.liveRoomId === post.liveRoomId)
                                ? { ...p, reviewStatus: newStatus } : p)
                            .filter(p => prev.tab === 'APPEALS' || !prev.reviewStatus || p.reviewStatus === prev.reviewStatus),
                        detail: prev.detail && prev.detail.recordingId === post.recordingId
                            && prev.detail.liveRoomId === post.liveRoomId
                            ? { ...prev.detail, reviewStatus: newStatus } : prev.detail,
                    }));
                } else {
                    toast.error('Thao tác thất bại: ' + res.data.message);
                }
            })
            .catch(() => toast.error('Có lỗi khi ' + (hide ? 'ẩn' : 'hiện') + ' bài đăng!'));
    }

    // Bấm vào 1 dòng → tải chi tiết bài đăng rồi tải bình luận từ RTDB.
    openDetail(post) {
        this.setState({ detail: null, detailLoading: true, comments: [], commentsLoading: true });

        axios.post(global.config.apiDomain
            + '/mc-live-room/web/group-posts/detail/' + post.liveRoomId + '/' + post.recordingId, {})
            .then(res => {
                if (res.data.status === 'OK') {
                    const detail = res.data.data;
                    this.setState({ detail, detailLoading: false });
                    this.loadComments(detail.commentRecordingId);
                } else {
                    toast.error('Không tải được chi tiết: ' + res.data.message);
                    this.setState({ detailLoading: false, commentsLoading: false });
                }
            })
            .catch(() => {
                toast.error('Có lỗi khi tải chi tiết bài đăng!');
                this.setState({ detailLoading: false, commentsLoading: false });
            });
    }

    // Đọc bình luận từ RTDB: ikara/recordingComments/{recordingId}, reply nằm ở node con "childs".
    loadComments(recordingId) {
        if (!recordingId) {
            this.setState({ comments: [], commentsLoading: false });
            return;
        }
        this.ikaraNode.child('recordingComments').child(String(recordingId))
            .orderByChild('dateTime').limitToLast(100).once('value')
            .then(snapshot => {
                const list = [];
                snapshot.forEach(cs => {
                    const c = cs.val() || {};
                    c.key = cs.key;
                    c.userProfile = this.fixUrl(c.userProfile);
                    if (c.childs) {
                        c.childReplies = Object.keys(c.childs).map(k => {
                            const r = c.childs[k] || {};
                            return { ...r, key: k, userProfile: this.fixUrl(r.userProfile) };
                        }).sort((a, b) => (a.dateTime || 0) - (b.dateTime || 0));
                    }
                    list.push(c);
                });
                list.sort((a, b) => (b.dateTime || 0) - (a.dateTime || 0)); // mới nhất lên đầu
                this.setState({ comments: list, commentsLoading: false });
            })
            .catch(() => this.setState({ comments: [], commentsLoading: false }));
    }

    closeDetail() {
        this.setState({ detail: null, comments: [] });
    }

    fixUrl(url) {
        if (!url) return url;
        return url.replace('http://', window.location.protocol + '//');
    }

    formatTimestamp(ms) {
        if (!ms) return '';
        return new Date(ms).toLocaleString('vi-VN', {
            year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
        });
    }

    // "x phút/giờ/ngày trước" cho gọn (giống mobile).
    timeAgo(ms) {
        if (!ms) return '';
        const diff = Date.now() - ms;
        const m = Math.floor(diff / 60000);
        if (m < 1) return 'vừa xong';
        if (m < 60) return m + ' phút trước';
        const h = Math.floor(m / 60);
        if (h < 24) return h + ' giờ trước';
        const d = Math.floor(h / 24);
        if (d < 30) return d + ' ngày trước';
        return this.formatTimestamp(ms);
    }

    formatCount(n) {
        if (n == null) return 0;
        if (n >= 1000000) return (n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 1) + 'M';
        if (n >= 1000) return (n / 1000).toFixed(n % 1000 === 0 ? 0 : 1) + 'K';
        return n;
    }

    // Chỉ BLOCKED mới coi là đang ẩn; các trạng thái kiểm duyệt khác vẫn hiển thị.
    isBlocked(x) {
        return x && x.reviewStatus === 'BLOCKED';
    }

    // Badge trạng thái kiểm duyệt (IReviewStatus).
    reviewBadge(status) {
        const map = {
            BLOCKED: { cls: 'badge-danger', text: 'BLOCKED (đang ẩn)' },
            ALLOWED: { cls: 'badge-success', text: 'ALLOWED' },
            PENDING: { cls: 'badge-secondary', text: 'PENDING' },
            REVIEWING: { cls: 'badge-warning', text: 'REVIEWING' },
        };
        const m = map[status] || { cls: 'badge-light', text: status || '—' };
        return <span className={'badge ' + m.cls}>{m.text}</span>;
    }

    // Badge trạng thái kháng cáo (IAppealStatus). null = chưa từng kháng cáo -> không vẽ gì.
    appealBadge(status) {
        if (!status) return null;
        const map = {
            PENDING: { cls: 'badge-warning', text: 'Chờ xử lý' },
            ACCEPTED: { cls: 'badge-success', text: 'Đã chấp nhận' },
            REJECTED: { cls: 'badge-dark', text: 'Đã từ chối' },
        };
        const m = map[status] || { cls: 'badge-light', text: status };
        return <span className={'badge ' + m.cls}>{m.text}</span>;
    }

    parseMedia(mediaJson) {
        if (!mediaJson) return [];
        try {
            const arr = JSON.parse(mediaJson);
            return Array.isArray(arr) ? arr : [];
        } catch (e) {
            return [];
        }
    }

    renderMediaBlock(detail) {
        if (detail.postType === 'SHARE_RECORDING') {
            return detail.videoUrl
                ? (
                    <div className="mb-3">
                        {detail.songName && <div className="mb-1"><i className="fa-solid fa-music mr-1"></i>{detail.songName}</div>}
                        <video src={detail.videoUrl} controls style={{ width: '100%', maxHeight: '60vh', background: '#000', borderRadius: 6 }} />
                    </div>
                )
                : <p className="text-muted">Bài chia sẻ nhưng không có link video.</p>;
        }
        if (detail.postType === 'IMAGE_VIDEO') {
            const items = this.parseMedia(detail.media);
            if (items.length === 0) return null;
            return (
                <div className="mb-3">
                    {items.map((it, i) => {
                        const url = typeof it === 'string' ? it : it.url;
                        const type = (it && it.type) || 'IMAGE';
                        if (!url) return null;
                        return type === 'VIDEO'
                            ? <video key={i} src={url} controls style={{ maxWidth: '100%', marginBottom: 8, borderRadius: 6 }} />
                            : <img key={i} src={url} alt="" style={{ maxWidth: '100%', marginBottom: 8, borderRadius: 6 }} />;
                    })}
                </div>
            );
        }
        return null;
    }

    renderComment(c, isReply) {
        return (
            <div key={c.key} className="d-flex mb-3" style={isReply ? { marginLeft: 40 } : {}}>
                <img
                    className="group-post-comment-avatar"
                    src={c.userProfile || 'https://via.placeholder.com/36'}
                    alt=""
                    onError={e => { e.target.style.visibility = 'hidden'; }}
                />
                <div className="ml-2">
                    <div>
                        <strong>{c.userName || 'Ẩn danh'}</strong>
                        <span className="text-muted ml-2" style={{ fontSize: 12 }}>{this.timeAgo(c.dateTime)}</span>
                        {c.likeCount ? <span className="ml-2 text-danger" style={{ fontSize: 12 }}>❤ {this.formatCount(c.likeCount)}</span> : null}
                    </div>
                    <div style={{ whiteSpace: 'pre-wrap' }}>{c.message}</div>
                    {c.childReplies && c.childReplies.map(r => this.renderComment(r, true))}
                </div>
            </div>
        );
    }

    renderDetailModal() {
        const { detail, detailLoading, comments, commentsLoading } = this.state;
        if (!detail && !detailLoading) return null;

        return (
            <div
                onClick={this.closeDetail}
                style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    background: 'rgba(0,0,0,0.6)', zIndex: 2000,
                    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
                }}
            >
                <div
                    onClick={e => e.stopPropagation()}
                    style={{ background: '#fff', borderRadius: 8, maxWidth: 640, width: '100%', maxHeight: '92vh', overflowY: 'auto' }}
                >
                    <div className="d-flex justify-content-between align-items-center p-3 border-bottom sticky-top bg-white">
                        <h5 className="m-0">Chi tiết bài đăng</h5>
                        <button type="button" className="close" onClick={this.closeDetail}><span>&times;</span></button>
                    </div>

                    {detailLoading && (
                        <div className="text-center p-4">
                            <div className="spinner-border text-primary" role="status"><span className="sr-only">Loading...</span></div>
                        </div>
                    )}

                    {detail && (
                        <div className="p-3">
                            {/* Header nhóm */}
                            <div className="mb-2">
                                <span className="font-weight-bold">{detail.groupName}</span>
                                {detail.groupRole && <span className="badge badge-info ml-2">{detail.groupRole}</span>}
                                <span className="badge badge-light ml-2">{detail.postType}</span>
                                <span className="ml-2">{this.reviewBadge(detail.reviewStatus)}</span>
                                {detail.appealStatus && (
                                    <span className="ml-2">Kháng cáo: {this.appealBadge(detail.appealStatus)}</span>
                                )}
                            </div>

                            {/* Người đăng */}
                            {detail.owner && (
                                <div className="d-flex align-items-center mb-3">
                                    <img
                                        src={this.fixUrl(detail.owner.profileImageLink) || 'https://via.placeholder.com/44'}
                                        alt=""
                                        style={{ width: 44, height: 44, borderRadius: '50%', objectFit: 'cover' }}
                                        onError={e => { e.target.style.visibility = 'hidden'; }}
                                    />
                                    <div className="ml-2">
                                        <div>
                                            <strong>{detail.owner.name}</strong>
                                            {detail.owner.level != null && (
                                                <span className="badge badge-warning ml-2" style={{ color: detail.owner.levelColor || undefined }}>
                                                    Lv {detail.owner.level}
                                                </span>
                                            )}
                                            {detail.owner.vipInfo && detail.owner.vipInfo.isVip && (
                                                <span className="badge badge-danger ml-1">VIP{detail.owner.vipInfo.vipLevel || ''}</span>
                                            )}
                                        </div>
                                        <div className="text-muted" style={{ fontSize: 12 }}>UID: {detail.owner.uid != null ? detail.owner.uid : '—'}</div>
                                        <div className="text-muted" style={{ fontSize: 12 }}>{this.timeAgo(detail.approvedDate)}</div>
                                    </div>
                                </div>
                            )}

                            {/* Caption */}
                            {detail.postMessage && <p style={{ whiteSpace: 'pre-wrap' }}>{detail.postMessage}</p>}

                            {/* Kháng cáo: lý do chủ bài trình bày. Đặt NGAY DƯỚI caption có chủ đích —
                                admin cần đọc lý do sát cạnh chính thứ bị tố, không phải cuộn xuống cuối. */}
                            {detail.appealStatus && (
                                <div className="alert alert-warning" style={{ whiteSpace: 'pre-wrap' }}>
                                    <div className="font-weight-bold mb-1">
                                        Lý do kháng cáo
                                        <span className="text-muted ml-2" style={{ fontSize: 12, fontWeight: 'normal' }}>
                                            {this.formatTimestamp(detail.appealAt)}
                                        </span>
                                    </div>
                                    {detail.appealMessage || <span className="text-muted">(không có nội dung)</span>}
                                    {detail.appealHandledAt && (
                                        <div className="text-muted mt-2" style={{ fontSize: 12 }}>
                                            Đã xử {this.formatTimestamp(detail.appealHandledAt)}
                                            {detail.appealHandledBy ? ' bởi ' + detail.appealHandledBy : ''}
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* Media / video */}
                            {this.renderMediaBlock(detail)}

                            {/* Thống kê */}
                            <div className="d-flex flex-wrap border-top border-bottom py-2 mb-3" style={{ gap: 16 }}>
                                <span>🎧 {this.formatCount(detail.viewCounter)} lượt nghe</span>
                                <span>❤ {this.formatCount(detail.noLike)} thích</span>
                                <span>💬 {this.formatCount(detail.noComment)} bình luận</span>
                                <span>🎁 {this.formatCount(detail.giftScore)}</span>
                            </div>

                            {/* Bình luận */}
                            <h6>Bình luận {detail.noComment ? '(' + this.formatCount(detail.noComment) + ')' : ''}</h6>
                            {commentsLoading && (
                                <div className="text-center p-2">
                                    <div className="spinner-border spinner-border-sm text-primary" role="status"><span className="sr-only">...</span></div>
                                </div>
                            )}
                            {!commentsLoading && comments.length === 0 && <p className="text-muted">Chưa có bình luận.</p>}
                            {comments.map(c => this.renderComment(c, false))}

                            {/* Hành động.
                                Bài đang chờ kháng cáo thì CHỈ có hai nút kháng cáo, không kèm Ẩn/Hiện.
                                "Chấp nhận kháng cáo" đã bao gồm việc hiện lại bài, nên bày thêm nút "Hiện lại
                                bài" cạnh nó là hai nút trông như hai lựa chọn mà thật ra một cái làm thiếu
                                việc: hiện bài mà không đóng kháng cáo thì nó nằm lại hàng chờ vĩnh viễn và
                                badge đếm một việc không còn tồn tại. */}
                            <div className="text-right border-top pt-3 mt-2">
                                {detail.appealStatus === 'PENDING' ? (
                                    <>
                                        <button className="btn btn-success mr-2" onClick={() => this.resolveAppeal(detail, true)}>
                                            Chấp nhận kháng cáo (hiện lại bài)
                                        </button>
                                        <button className="btn btn-secondary" onClick={() => this.resolveAppeal(detail, false)}>
                                            Từ chối (giữ bài ẩn)
                                        </button>
                                    </>
                                ) : (this.isBlocked(detail)
                                    ? <button className="btn btn-info" onClick={() => this.toggleHidden(detail, false)}>Hiện lại bài</button>
                                    : <button className="btn btn-danger" onClick={() => this.toggleHidden(detail, true)}>Ẩn bài này</button>)}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }

    render() {
        const { posts, tab, appealCount, reviewStatus } = this.state;
        const laTabKhangCao = tab === 'APPEALS';
        return (
            <div id="content">
                <div className="container-fluid">
                    <h1 className="text-center">Quản lí Bài đăng nhóm</h1>

                    <ul className="nav nav-tabs mb-3">
                        <li className="nav-item">
                            <a
                                href="#posts"
                                className={'nav-link ' + (laTabKhangCao ? '' : 'active')}
                                onClick={e => { e.preventDefault(); this.switchTab('POSTS'); }}
                            >
                                Bài đăng
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                href="#appeals"
                                className={'nav-link ' + (laTabKhangCao ? 'active' : '')}
                                onClick={e => { e.preventDefault(); this.switchTab('APPEALS'); }}
                            >
                                Kháng cáo
                                {appealCount > 0 && <span className="badge badge-danger ml-2">{appealCount}</span>}
                            </a>
                        </li>
                    </ul>

                    <p className="text-center text-muted">
                        {laTabKhangCao
                            ? 'Bài bị AI hoặc admin chặn, chủ bài xin xem lại. Cũ nhất trước. Chấp nhận = gỡ chặn; Từ chối = giữ nguyên và chủ bài không kháng cáo lại được nữa.'
                            : 'Bấm vào một dòng để xem chi tiết. Ẩn một bài sẽ làm nó biến mất khỏi tất cả newsfeed — không ai nhìn thấy.'}
                    </p>

                    {!laTabKhangCao && (
                        <div className="form-inline mb-3">
                            <label htmlFor="group-post-review-status" className="mr-2">Trạng thái kiểm duyệt</label>
                            <select id="group-post-review-status" className="form-control" value={reviewStatus} onChange={this.changeReviewStatus}>
                                <option value="">Tất cả</option>
                                <option value="ALLOWED">ALLOWED</option>
                                <option value="REVIEWING">REVIEWING</option>
                                <option value="PENDING">PENDING</option>
                                <option value="BLOCKED">BLOCKED</option>
                            </select>
                        </div>
                    )}

                    <table className="table table-hover">
                        <thead>
                            <tr className="text-center">
                                <th className="align-middle" scope="col">#</th>
                                <th className="align-middle" scope="col">Loại</th>
                                <th className="align-middle" scope="col">Nội dung</th>
                                {laTabKhangCao && <th className="align-middle" scope="col">Lý do kháng cáo</th>}
                                <th className="align-middle" scope="col">Nhóm</th>
                                <th className="align-middle" scope="col">Tác giả</th>
                                <th className="align-middle" scope="col">{laTabKhangCao ? 'Kháng cáo lúc' : 'Thời gian'}</th>
                                <th className="align-middle" scope="col">Kiểm duyệt</th>
                                <th className="align-middle" scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(posts || []).map((post, index) => {
                                const hidden = this.isBlocked(post);
                                return (
                                    <tr
                                        key={post.liveRoomId + '#' + post.recordingId}
                                        onClick={() => this.openDetail(post)}
                                        style={{ cursor: 'pointer' }}
                                        className={hidden && !laTabKhangCao ? 'text-muted' : ''}
                                    >
                                        <td className="text-center align-middle">{index + 1}</td>
                                        <td className="text-center align-middle">
                                            <span className="badge badge-light">{post.postType}</span>
                                        </td>
                                        <td className="align-middle" style={{ maxWidth: 320, wordBreak: 'break-word' }}>
                                            {hidden && !laTabKhangCao ? <del>{post.postMessage}</del> : post.postMessage}
                                        </td>
                                        {laTabKhangCao && (
                                            <td className="align-middle" style={{ maxWidth: 320, wordBreak: 'break-word' }}>
                                                {post.appealMessage}
                                            </td>
                                        )}
                                        <td className="text-center align-middle">{post.groupName}</td>
                                        <td className="text-center align-middle">
                                            <div>{post.ownerName}</div>
                                            <small className="text-muted">UID: {post.ownerUid != null ? post.ownerUid : '—'}</small>
                                        </td>
                                        <td className="text-center align-middle">
                                            {this.formatTimestamp(laTabKhangCao ? post.appealAt : post.approvedDate)}
                                        </td>
                                        <td className="text-center align-middle">
                                            {this.reviewBadge(post.reviewStatus)}
                                            {!laTabKhangCao && post.appealStatus && (
                                                <div className="mt-1">{this.appealBadge(post.appealStatus)}</div>
                                            )}
                                        </td>
                                        <td className="text-center align-middle" style={{ whiteSpace: 'nowrap' }}>
                                            {laTabKhangCao ? (
                                                <>
                                                    <button
                                                        className="btn btn-success btn-sm mr-1"
                                                        onClick={e => { e.stopPropagation(); this.resolveAppeal(post, true); }}
                                                    >
                                                        Chấp nhận
                                                    </button>
                                                    <button
                                                        className="btn btn-secondary btn-sm"
                                                        onClick={e => { e.stopPropagation(); this.resolveAppeal(post, false); }}
                                                    >
                                                        Từ chối
                                                    </button>
                                                </>
                                            ) : (hidden
                                                ? <button className="btn btn-info btn-sm" onClick={e => { e.stopPropagation(); this.toggleHidden(post, false); }}>Hiện</button>
                                                : <button className="btn btn-danger btn-sm" onClick={e => { e.stopPropagation(); this.toggleHidden(post, true); }}>Ẩn</button>)}
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>

                    {this.state.isLoading && (
                        <div className="text-center p-3">
                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                        </div>
                    )}
                    {this.state.cursor === 'END' && (
                        <div className="text-center p-3">
                            <p className="text-muted">
                                {laTabKhangCao
                                    ? (posts.length === 0 ? 'Không có kháng cáo nào đang chờ' : 'Đã hiển thị tất cả kháng cáo')
                                    : 'Đã hiển thị tất cả bài đăng'}
                            </p>
                        </div>
                    )}
                </div>
                {this.renderDetailModal()}
            </div>
        );
    }
}
